import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import Api from '../../common/services/api.service';

const url = 'uploadFile';
//const url = 'http://192.168.1.229:8000/sonavie/uploadFile';
//const serviceUrl = "http://192.168.1.229:8000/sonavie/fileDeal";
const serviceUrl = "fileDeal";

const httpOptions = { 
  reportProgress: true,
  headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
};




@Injectable()
export class FileDialogService {

  completed = false;
  constructor(private api: Api) {}

 public upload(files: Set<File>): {[key:string]:Observable<number>} {
   
    const status = {};
    

    files.forEach(file => {
      
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);

     
      const req = new HttpRequest('POST', url, formData, {reportProgress: true});
      ///console.log("FormData: ", formData);

    
    
      const progress = new Subject<number>();

     
      this.api.request(req).subscribe(event => {
        ///console.log("Req Send event", req);
        if (event.type === HttpEventType.UploadProgress) {
          ///console.log("Progression", req);
          // calculate the progress percentage
          const percentDone = Math.round(100 * event.loaded / event.total);

          // pass the percentage into the progress-stream
          progress.next(percentDone);
          this.completed = true;

          ///console.log("Pourcentage: ", percentDone);
        } else if (event instanceof HttpResponse) {

          
          progress.complete();
          
          
        }
      });

      // Save every progress-observable in a map of all observables
      status[file.name] = {
        progress: progress.asObservable()
      };
      
    });

    // return the map of progress.observables
    ///console.log(status);
    return status;
  }

  isProgressCompleted() {
    return this.completed;
  }
}
/*

, data => {
  console.log("Upload respose data: ", data);
  
  if (data){
    console.log("Upload respose data in condition: ", data);
     this.api.get(serviceUrl).subscribe((val)=>{
      console.log("Valeur: ", val);
    });
  }
}*/


// WEBPACK FOOTER //
// ./src/app/admin-app/services/file-dialog.service.ts